(function ($) {
	var trackComment = function (comment) {
		var data = {
			'event': 'WasThisPageHelpfulComment',
			'comment': comment
		};
		window.tracking.trackEvent(data);
	};

	var trackResponse = function(response) {
		var data = {
			'event': 'WasThisPageHelpfulResponse',
			'response': response
		};
		window.tracking.trackEvent(data);
	};

	var sendEmail = function(comment) {
		$.ajax({
			method: 'POST',
			url: 'SendEmail',
			data: {
				url: window.location.href,
				comment: comment
			},
			error: function(xhr, status, error) {
				$('.js-was-this-page-helpful-comment').slideToggle(500,
					function () {
						$('.js-was-this-page-helpful-response-error').fadeTo(400, 1);
						$('.js-was-this-page-helpful-response-error').attr('role', 'alert');
					});
			},
			success: function(xhr, status, error) {
				$('.js-was-this-page-helpful-comment').slideToggle(500,
					function () {
						$('.js-was-this-page-helpful-response').fadeTo(400, 1);
						$('.js-was-this-page-helpful-response').attr('role', 'alert');
					});
			}
		});
	};

	$('.js-was-this-page-helpful-button').on('click',
		function () {
			var status = $(this).val();
			trackResponse(status);
			$('.js-was-this-page-helpful-form').fadeOut(400, function() {
				$('.js-was-this-page-helpful-comment').slideToggle(500);
				$('.js-was-this-page-helpful-comment-textarea').focus();
			});
		});

	$('.js-was-this-page-helpful-comment-submit').on('click',
		function () {
			var comment = $('.js-was-this-page-helpful-comment-textarea').val();
			if (comment.trim()) {
				trackComment(comment);
				sendEmail(comment);
			}
		});
})(jQuery);
